import { IUpdateEntregaObrasClienteChecklistUseCase } from "../../../presentation/useCases/update/update_entrega_obras_cliente_checklist_use_case";
import { VerificacaoChecklistModel } from "../../models/verificacao_checklist";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * UpdateEntregaObrasClienteChecklistUseCase
 */

export class UpdateEntregaObrasClienteChecklistUseCase implements IUpdateEntregaObrasClienteChecklistUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(
    idEntregaObraCliente: number,
    localVistoria?: string,
    idFuncionarioInsp?: number,
    idFuncionarioReinsp?: number,
    dataInspecao?: Date,
    dataReinsp?: Date,
    status?: number,
    analiseVistoria?: string,
    itensChecklist?: VerificacaoChecklistModel[]): Promise<void> {
    await this.repository.updateEntregaObrasClienteChecklistById(
      idEntregaObraCliente,
      localVistoria,
      idFuncionarioInsp,
      idFuncionarioReinsp,
      dataInspecao,
      dataReinsp,
      status,
      analiseVistoria,
      itensChecklist ?? []
    );
  }
}
